import styled from "styled-components"

const ContentWrapper = styled.div``

export default ContentWrapper
